import request from './request'

export function getCrossingProducts () {
  return request({
    url: '/products?type=crossings',
    method: 'get'
  })
}

export function getMixedProducts () {
  return request({
    url: '/products?type=mixed',
    method: 'get'
  })
}

export function getAnnualityProducts () {
  return request({
    url: '/products?type=annuality',
    method: 'get'
  })
}

export function getRechargeProducts () {
  return request({
    url: '/products?type=recharge',
    method: 'get'
  })
}
